/* eslint-disable tailwindcss/no-custom-classname */
import { Container } from "@/components/molecules/Container";
import { Inner } from "@/components/molecules/Inner";
import Careers from "@/components/organisms/Careers";
import Contact from "@/components/organisms/Contact";
import { TermHead } from "@/components/organisms/TermHead";
import TermNav from "@/components/organisms/TermNav";
import { Footer } from "@/components/templates/Footer";
import { Header } from "@/components/templates/Header";
import Layout from "@/components/templates/Layout";
import Meta from "@/components/templates/Meta";
import { useBudouX } from "@/hooks/useBudouX";

const textBody = [
  {
    head: "販売事業者名",
    body: "株式会社トッカシステムズ",
  },
  {
    head: "運営責任者名",
    body: "代表取締役　谷 樹",
  },
];
const textBodyAdd = [
  {
    head: "商品引き渡し時期",
    body: "制作初期費用のお支払いを確認後制作開始、およそ3週間後納品",
  },
  {
    head: "返品・交換不良品について",
    body: "商品の特性上、返金・キャンセルについてはお受けできません。",
  },
  {
    head: "解約手続きについて",
    body: "当初1年は解約は不可とします。1年以降は、30日前までの書面又はメールでの事前通知により解約可能とします。事前通知が30日未満の場合、当月分の管理費用のお支払いをお願いいたします。解約の届け出を確認後、利用サービスの契約終了をもって、契約の解約といたします。また、既に支払いいただいた料金の返金は致しかねます。",
  },
];

export default function LegalPage() {
  const { parse } = useBudouX();
  const isHeaderRelative = true;
  return (
    <>
      <Meta
        pageTitle={"特定商取引法に基づく表記"}
        pageDescription={
          "株式会社トッカシステムズの特定商取引法に基づく表記です。日進月歩のデジタルテクノロジー分野において『お客様のビジネスに特化（Tocca）したシステムを』という理念を社名に込めて、使える・価値のあるシステムを提供します。"
        }
        pagePath={"https://tocca.systems/legal/"}
      />
      <Layout>
        <Header isRelative={isHeaderRelative} />
        <main className="flex-1">
          <Container>
            <Inner className="mx-auto box-border flex max-w-6xl flex-col py-10 px-6 text-pri sm:px-8 md:px-12 md:pt-16 md:pb-24">
              <TermNav />
              <div className="order-1 md:order-2">
                <TermHead>特定商取引法に基づく表記</TermHead>
                <div className="grid-rows-8 grid space-y-2 divide-y divide-x-0 divide-solid divide-bdc-light text-base text-txt-base md:space-y-2">
                  {textBody.map((textBody) => (
                    <dl
                      key={textBody.head}
                      className="
                      grid
                      grid-flow-dense
                      grid-cols-none
                      pt-2
                      text-base
                      first:pt-0
                      md:grid-flow-col
                      md:grid-cols-3
                      md:gap-12"
                    >
                      <dt className="col-auto inline-block font-bold text-pri md:col-span-1 md:text-txt-light">
                        <div
                          dangerouslySetInnerHTML={{ __html: textBody.head }}
                        />
                      </dt>
                      <dd className="col-auto	md:col-span-2">
                        {parse(textBody.body)}
                      </dd>
                    </dl>
                  ))}
                  <dl
                    key={textBody.head}
                    className="
                      grid
                      grid-flow-dense
                      grid-cols-none
                      gap-0
                      pt-2
                      first:pt-0
                      md:grid-flow-col
                      md:grid-cols-3
                      md:gap-12"
                  >
                    <dt className="col-auto inline-block font-bold text-pri md:col-span-1 md:text-txt-light">
                      本社所在地
                    </dt>
                    <dd className="col-auto	md:col-span-2">
                      <dl className="flex flex-col flex-wrap items-start justify-start gap-0 text-txt-base md:flex-row md:items-center md:gap-2 md:text-base">
                        <dt className="text-txt-light md:min-w-[40px]">住所</dt>
                        <dd>
                          101-0051 東京都千代田区神田神保町2-20 ワカヤギビル3階
                        </dd>
                      </dl>
                      <dl className="flex flex-col flex-wrap items-start justify-start gap-0 text-txt-base md:flex-row md:items-center md:gap-2 md:text-base">
                        <dt className="text-txt-light md:min-w-[40px]">TEL</dt>
                        <dd>03-5213-4278</dd>
                      </dl>
                      <dl className="flex flex-col flex-wrap items-start justify-start gap-0 text-txt-base md:flex-row md:items-center md:gap-2 md:text-base">
                        <dt className="text-txt-light md:min-w-[40px]">FAX</dt>
                        <dd>03-5213-4279</dd>
                      </dl>
                      <dl className="flex flex-col flex-wrap items-start justify-start gap-0 text-txt-base md:flex-row md:items-center md:gap-2 md:text-base">
                        <dt className="text-txt-light md:min-w-[40px]">mail</dt>
                        <dd>info@tocca-net.jp</dd>
                      </dl>
                      <dl className="flex flex-col flex-wrap items-start justify-start gap-0 text-txt-base md:flex-row md:items-center md:gap-2 md:text-base">
                        <dt className="text-txt-light md:min-w-[40px]">url</dt>
                        <dd>https://tocca.systems/</dd>
                      </dl>
                    </dd>
                  </dl>
                  <dl
                    key={textBody.head}
                    className="
                      grid
                      grid-flow-dense
                      grid-cols-none
                      gap-0
                      pt-2
                      first:pt-0
                      md:grid-flow-col
                      md:grid-cols-3
                      md:gap-12"
                  >
                    <dt className="col-auto inline-block font-bold text-pri md:col-span-1 md:text-txt-light">
                      代金の支払い時期
                    </dt>
                    <dd className="col-auto	md:col-span-2">
                      <dl className="text-base text-txt-base">
                        <dt className="font-bold text-txt-light">
                          ホームページ初期制作費用
                        </dt>
                        <dd>{parse("銀行振込（制作お申し込み時）")}</dd>
                      </dl>
                      <dl className="text-base text-txt-base">
                        <dt className="font-bold text-txt-light">
                          ホームページ運用月額費用
                        </dt>
                        <dd>
                          {parse(
                            "口座振替（口座振替運用が開始されるまでは、銀行振込。運用開始後は、毎月22日に引き落とし）"
                          )}
                        </dd>
                        <dd>
                          {parse(
                            "クレジットカード決済（運用開始時、翌月以降毎月末日請求）"
                          )}
                        </dd>
                      </dl>
                      <dl className="text-base text-txt-base">
                        <dt className="font-bold text-txt-light">
                          その他オプション使用料
                        </dt>
                        <dd>
                          {parse(
                            "口座振替（口座振替運用が開始されるまでは、銀行振込。運用開始後は、毎月22日に引き落とし）"
                          )}
                        </dd>
                        <dd>
                          {parse(
                            "クレジットカード決済（運用開始時、翌月以降毎月末日請求）"
                          )}
                        </dd>
                      </dl>
                    </dd>
                  </dl>
                  {textBodyAdd.map((textBodyAdd) => (
                    <dl
                      key={textBodyAdd.head}
                      className="
                      grid
                      grid-flow-dense
                      grid-cols-none
                      gap-0
                      pt-2
                      text-base
                      first:pt-0
                      md:grid-flow-col
                      md:grid-cols-3
                      md:gap-12"
                    >
                      <dt className="col-auto inline-block font-bold text-pri md:col-span-1 md:text-txt-light">
                        <div
                          dangerouslySetInnerHTML={{ __html: textBodyAdd.head }}
                        />
                      </dt>
                      <dd className="col-auto	md:col-span-2">
                        {parse(textBodyAdd.body)}
                      </dd>
                    </dl>
                  ))}
                </div>
              </div>
            </Inner>
          </Container>
        </main>
        <Careers />
        <Contact />
        <Footer />
      </Layout>
    </>
  );
}
